<template>
  <b-card>
    <b-row>
      <b-col>
        <b-form-group
          label="Başlangıç Tarihi"
          label-for="sdate"
        >
          <b-form-datepicker
            id="sdate"
            v-model="filterParams.sdate"
            v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
            locale="tr"
            start-weekday="1"
            @input="getReport"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group
          label="Bitiş Tarihi"
          label-for="edate"
        >
          <b-form-datepicker
            id="edate"
            v-model="filterParams.edate"
            v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
            locale="tr"
            start-weekday="1"
            @input="getReport"
          />
        </b-form-group>
      </b-col>

    </b-row>
  </b-card>
</template>
<script>
import {
  BRow, BCol, BCard, BFormDatepicker, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'FilterData',
  components: {
    BRow,
    BCol,
    BCard,
    BFormDatepicker,
    BFormGroup,
    vSelect,
  },
  props: {
    getReport: {
      type: Function,
      require: true,
    },
  },
  computed: {
    filterParams() {
      return this.$store.getters['interviewReports/filterParams']
    },
    users() {
      return this.$store.getters['users/dataList']
    },
  },
  created() {
    this.getUsers()
  },
  methods: {
    getUsers() {
      this.$store.dispatch('users/getDataList', {
        select: ['users.id AS id', 'users.name AS name'],
        where: {
          'users.status': 1,
          // 'users.id_user_types >': 1,
        },
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
